import { NavMenu, FooterApp } from '..';

function Layout({ children }) {
	return (
		<>
			<NavMenu />
			<main id='main-app'>{children}</main>
			{/* <FooterApp /> */}
		</>
	);
}

export default Layout;
